var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addButtonText",on:{"click":function($event){return _vm.$emit('click')}}},[_c('Icon',{staticClass:"icon-add",attrs:{"name":"add"}}),_c('span',[_vm._v("添加任务")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }